import { createSelector } from "@reduxjs/toolkit"
import { FormRootState } from "./formStore"
import { ConceptStatusValueType } from "@fusion-advantage/backcompat"

export const selectLastChosenAt = createSelector(
	(state: FormRootState) => state.form.statusHistory,
	(statusHistory): string|null => {
		for(let item of statusHistory) {
			if(item.valueType === ConceptStatusValueType.Chosen) {
				return item.updatedAt
			}
		}
		return null
	}
)
